<template>
    <button><slot></slot></button>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
button{
    border-radius: 32px;
    background: rgb(255, 183, 16);
    height: 44px;
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 2px solid transparent;
    transition: all 0.3s ease-in-out;
    z-index: 1;
}
button.white:hover {
  background: transparent;
  border-color: rgb(255, 183, 16);
  color: white;
}
button:hover {
  background: transparent;
  border-color: rgb(255, 183, 16);
}
button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;
  height: 100%;
  background: rgb(255, 183, 16);
  transition: all 0.3s ease-in-out;
}

button:hover::before {
  transform: translateY(-100%);
}
</style>